import { faqData } from '@/mocks/homepage';

export default function FaqSection() {
  return (
    <section id="faq" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">常见问题</h2>
          <p className="text-sm text-foreground-500 mt-2">关于吃瓜官网你想知道的一切</p>
        </div>
        <div className="space-y-3">
          {faqData.map((item) => (
            <div key={item.id} className="bg-background-100 rounded-2xl p-5">
              <div className="flex items-start gap-3">
                <span className="w-7 h-7 flex-shrink-0 flex items-center justify-center bg-primary-100 rounded-lg mt-0.5">
                  <span className="text-sm font-heading font-bold text-primary-600">Q</span>
                </span>
                <div className="flex-1">
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900">{item.q}</h3>
                  <p className="text-sm text-foreground-600 mt-2 leading-relaxed">{item.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}